import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { IInflectTableCellAugmented } from 'models/InflectsModel';
import KeyContext from '../../../CMFW/context/KeyContext';
import { createKeyPath } from '../../../CMFW/context/helper/keyContext';

interface ITableCellContentProps {
  cell?: IInflectTableCellAugmented;
  parentKey: string;
  cellRenderer: ReactNode;
}

const CellWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  min-height: 28px;
`;

const EmptyCell = styled.div`
  width: 100%;
  height: 100%;
  min-height: 28px;
`;

export const TableCellContent: React.FC<ITableCellContentProps> = ({ cell, parentKey, cellRenderer }) => {
  if (!cell) {
    return <EmptyCell />;
  }
  
  return (
    <>
      {cell.values.map((value, index) => (
        <CellWrapper key={value.inflectId + '-' + index}>
          <KeyContext.Provider value={createKeyPath(parentKey, '', value.index)}>
            {cellRenderer}
          </KeyContext.Provider>
        </CellWrapper>
      ))}
    </>
  );
};